import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import { IAllOriginConfiguration, IOriginConfiguration } from '../@interfaces/configuration';

@Injectable()
export class ConfigurationService {
  private ITURAN = 'Ituran';
  private WD = 'Webdespachantes';
  private PAYN = 'Payn';
  private AUTOSCORE = 'Autoscore';
  private MEGABEM = 'Mega Bem';
  private CDL = 'CDL';
  private AGILIZEAUTO = 'Agilize Auto';
  private AUTOAVALIAR = 'Auto Avaliar';
  private PROTEGEFACIL = 'Protege Fácil';
  private CARROOK = 'Carro OK';
  private YOUDESP = 'YouDesp';
  private G30 = 'G30';
  private DESPAPAG = 'Despapag';
  private OLX = 'OLX';
  private AUTOCONF = 'AutoConf';

  private WD_ORIGIN = 'WEBDESPACHANTES';
  private ITURAN_ORIGIN = 'ITURAN';
  private PAYN_ORIGIN = 'PAYN';
  private AUTOSCORE_ORIGIN = 'AUTOSCORE';
  private MEGABEM_ORIGIN = 'MEGABEM';
  private CDL_ORIGIN = 'CDL';
  private AGILIZEAUTO_ORIGIN = 'AGILIZEAUTO';
  private AUTOAVALIAR_ORIGIN = 'AUTOAVALIAR';
  private PROTEGEFACIL_ORIGIN = 'PROTEGEFACIL';
  private CARROOK_ORIGIN = 'CARROOK';
  private YOUDESP_ORIGIN = 'YOUDESP';
  private G30_ORIGIN = 'G30';
  private DESPAPAG_ORIGIN = 'DESPAPAG';
  private OLX_ORIGIN = 'OLX';
  private AUTOCONF_ORIGIN = 'AUTOCONF';

  private CONFIGS: IAllOriginConfiguration = {
    [this.WD_ORIGIN]: {
      name: this.WD,
      style: 'customization-wd.css?version=' + environment.version,
      origin: this.WD_ORIGIN,
      logo: ['assets/images/pinpag.png'],
      footer_logo: '',
      email: 'sac@webdespachantes.com.br',
      phone: '(11) 4223-7590',
      intermediary_document: '17803384000183', // Default
      service_amount: 0,
      service_amount_percentage: 0,
    },
    [this.ITURAN_ORIGIN]: {
      name: this.ITURAN,
      style: 'customization-ituran.css?version=' + environment.version,
      origin: this.ITURAN_ORIGIN,
      logo: ['assets/images/pinpag.png'],
      footer_logo: '',
      form_logo: 'assets/images/logo-ituran.png',
      form_manual: 'Dúvidas de como funciona o parcelamento? ' +
        '<a href="/assets/images/PINPAG_ITURAN.pdf" target="_blank" rel="noopener noreferrer">Clique aqui</a>.',
      form_description: 'Com a parceria entre Ituran e PinPag, é possível parcelar\
        os débitos veiculares em até <b>21x</b> no cartão de crédito.',
      email: 'sac@pinpag.com.br',
      phone: '(11) 4223-7590',
      intermediary_document: '16613061000164',
      service_amount: 0,
      service_amount_percentage: 0,
    },
    [this.PAYN_ORIGIN]: {
      name: this.PAYN,
      style: 'customization-payn.css?version=' + environment.version,
      origin: this.PAYN_ORIGIN,
      logo: ['assets/images/logo-payn.png'],
      footer_logo: '',
      email: 'sac@pinpag.com.br',
      phone: '(11) 4223-7590',
      intermediary_document: '55995919000154',
      service_amount: 0,
      service_amount_percentage: 500,
    },
    [this.AUTOSCORE_ORIGIN]: {
      name: this.AUTOSCORE,
      style: 'customization-autoscore.css?version=' + environment.version,
      origin: this.AUTOSCORE_ORIGIN,
      logo: ['assets/images/logo-autoscore.png'],
      footer_logo: '',
      email: 'sac@pinpag.com.br',
      phone: '(11) 4223-7590',
      intermediary_document: '37324169000107',
      service_amount: 0,
      service_amount_percentage: 0,
    },
    [this.MEGABEM_ORIGIN]: {
      name: this.MEGABEM,
      style: 'customization-megabem.css?version=' + environment.version,
      origin: this.MEGABEM_ORIGIN,
      logo: ['assets/images/logo-megabem.png'],
      footer_logo: '',
      email: 'sac@pinpag.com.br',
      phone: '(11) 4223-7590',
      intermediary_document: '52047239000110',
      service_amount: 0,
      service_amount_percentage: 0,
    },
    [this.CDL_ORIGIN]: {
      name: this.CDL,
      style: 'customization-cdl.css?version=' + environment.version,
      origin: this.CDL_ORIGIN,
      logo: ['assets/images/logo-cdl.png'],
      footer_logo: '',
      email: 'sac@pinpag.com.br',
      phone: '(11) 4223-7590',
      intermediary_document: '03132763000184',
      service_amount: 3500,
      service_amount_percentage: 0,
    },
    [this.AGILIZEAUTO_ORIGIN]: {
      name: this.AGILIZEAUTO,
      style: 'customization-agilizeauto.css?version=' + environment.version,
      origin: this.AGILIZEAUTO_ORIGIN,
      logo: ['assets/images/logo-agilizeauto.png'],
      footer_logo: '',
      email: 'sac@pinpag.com.br',
      phone: '(11) 4223-7590',
      intermediary_document: '60119449000103',
      service_amount: 7500,
      service_amount_percentage: 0,
    },
    [this.AUTOAVALIAR_ORIGIN]: {
      name: this.AUTOAVALIAR,
      style: 'customization-autoavaliar.css?version=' + environment.version,
      origin: this.AUTOAVALIAR_ORIGIN,
      logo: ['assets/images/logo-autoavaliar.png'],
      footer_logo: '',
      email: 'sac@pinpag.com.br',
      phone: '(11) 4223-7590',
      intermediary_document: '22279800000479',
      service_amount: 0,
      service_amount_percentage: 0,
    },
    [this.PROTEGEFACIL_ORIGIN]: {
      name: this.PROTEGEFACIL,
      style: 'customization-protegefacil.css?version=' + environment.version,
      origin: this.PROTEGEFACIL_ORIGIN,
      logo: ['assets/images/logo-protegefacil.png'],
      footer_logo: '',
      email: 'sac@pinpag.com.br',
      phone: '(11) 4223-7590',
      intermediary_document: '58947642000182',
      service_amount: 0,
      service_amount_percentage: 1500,
    },
    [this.CARROOK_ORIGIN]: {
      name: this.CARROOK,
      style: 'customization-carrook.css?version=' + environment.version,
      origin: this.CARROOK_ORIGIN,
      logo: ['assets/images/logo-carrook.png'],
      footer_logo: '',
      email: 'sac@pinpag.com.br',
      phone: '(11) 4223-7590',
      intermediary_document: '35648556000173',
      service_amount: 0,
      service_amount_percentage: 0,
    },
    [this.YOUDESP_ORIGIN]: {
      name: this.YOUDESP,
      style: 'customization-youdesp.css?version=' + environment.version,
      origin: this.YOUDESP_ORIGIN,
      logo: ['assets/images/logo-youdesp.png'],
      footer_logo: '',
      email: 'sac@pinpag.com.br',
      phone: '(11) 4223-7590',
      intermediary_document: '58051032000104',
      service_amount: 0,
      service_amount_percentage: 0,
    },
    [this.G30_ORIGIN]: {
      name: this.G30,
      style: 'customization-g30.css?version=' + environment.version,
      origin: this.G30_ORIGIN,
      logo: ['assets/images/logo-g30.png'],
      footer_logo: '',
      email: 'sac@pinpag.com.br',
      phone: '(11) 4223-7590',
      intermediary_document: '55617458000186',
      service_amount: 0,
      service_amount_percentage: 0,
    },
    [this.DESPAPAG_ORIGIN]: {
      name: this.DESPAPAG,
      style: 'customization-despapag.css?version=' + environment.version,
      origin: this.DESPAPAG_ORIGIN,
      logo: ['assets/images/logo-despapag.png'],
      footer_logo: '',
      email: 'sac@pinpag.com.br',
      phone: '(11) 4223-7590',
      intermediary_document: '09289284000152',
      service_amount: 0,
      service_amount_percentage: 0,
    },
    [this.OLX_ORIGIN]: {
      name: this.OLX,
      style: 'customization-olx.css?version=' + environment.version,
      origin: this.OLX_ORIGIN,
      logo: ['assets/images/logo-olx.png'],
      footer_logo: '',
      email: 'sac@pinpag.com.br',
      phone: '(11) 4223-7590',
      intermediary_document: '11818248000180',
      service_amount: 0,
      service_amount_percentage: 0,
    },
    [this.AUTOCONF_ORIGIN]: {
      name: this.AUTOCONF,
      style: 'customization-autoconf.css?version=' + environment.version,
      origin: this.AUTOCONF_ORIGIN,
      logo: ['assets/images/logo-autoconf.png'],
      footer_logo: '',
      email: 'sac@pinpag.com.br',
      phone: '(41) 99156-5056',
      intermediary_document: '32385639000129',
      service_amount: 0,
      service_amount_percentage: 0,
    },
  };

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) { }

  get config(): IOriginConfiguration {
    return this.getConfig();
  }

  public getConfig() {
    return this.CONFIGS[this.getConfigUrl()];
  }

  protected getConfigUrl(): string {
    const url = this.document.URL;

    if (url.includes('ituran')) {
      return this.ITURAN_ORIGIN;
    }

    if (url.includes('payn')) {
      return this.PAYN_ORIGIN;
    }

    if (url.includes('autoscore')) {
      return this.AUTOSCORE_ORIGIN;
    }

    if (url.includes('megabem')) {
      return this.MEGABEM_ORIGIN;
    }

    if (url.includes('cdl')) {
      return this.CDL_ORIGIN;
    }

    if (url.includes('agilizeauto')) {
      return this.AGILIZEAUTO_ORIGIN;
    }

    if (url.includes('autoavaliar')) {
      return this.AUTOAVALIAR_ORIGIN;
    }

    if (url.includes('protegefacil')) {
      return this.PROTEGEFACIL_ORIGIN;
    }

    if (url.includes('carrook')) {
      return this.CARROOK_ORIGIN;
    }

    if (url.includes('youdesp')) {
      return this.YOUDESP_ORIGIN;
    }

    if (url.includes('g30')) {
      return this.G30_ORIGIN;
    }

    if (url.includes('despapag')) {  
      return this.DESPAPAG_ORIGIN;
    }

    if (url.includes('olx')) {
      return this.OLX_ORIGIN;
    }

    if (url.includes('autoconf')) {
      return this.AUTOCONF_ORIGIN;
    }

    // default
    return this.WD_ORIGIN;
  }
}
